import React from 'react'

import MarketVolatilitySection from './MarketVolatilitySection'

const App = props => {
  const { introduction, description } = props
  return (
    <MarketVolatilitySection
      introduction={introduction}
      description={description}
      accumulation={true}
      idPrefix='accumulation'
    />
  )
}

export default App
